var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("line",{"fill":"none","strokeWidth":"6","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"35.076","y1":"35.077","x2":"64.924","y2":"64.924","key":0}),React.createElement("line",{"fill":"none","strokeWidth":"6","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"35.076","y1":"64.923","x2":"64.924","y2":"35.076","key":1})]),React.createElement("circle",{"fill":"none","strokeWidth":"6","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"50","cy":"50","r":"39.083","key":1})]);
}

X.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = X;

X.default = X;
